import { AxiosResponse } from 'axios';

const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;

export function extractFilenameFromHeaders(response: AxiosResponse): string | null {
    const disposition = response.headers['content-disposition'];
    if (disposition && disposition.indexOf('attachment') !== -1) {
        const matches = filenameRegex.exec(disposition);
        if (matches != null && matches[1]) {
            return matches[1].replace(/['"]/g, '');
        }
    }
    return null;
}
